import { useState, useEffect, useRef } from "react";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";
import validEmail from "../../utils/emailUtils";

function formatPhoneNumber(value) {
  if (!value) return "";

  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}

let obj = {
  contactEmail: "",
  phone: "",
  tfaOn: false,
};

const TwoFactorPreReg = () => {
  const { userToken, SetSharedObject } = useUserStore((state) => ({
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
  }));
  const [flag, setFlag] = useState(false);
  const [flagSuccess, setFlagSuccess] = useState(false);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [answers, setAnswers] = useState(obj);
  const [errEmail, SetErrEmail] = useState(false);
  const modalTriggerRef = useRef(null);
  const firstFocusableRef = useRef(null);
  const modalRef = useRef(null);
  const closeBtnRef = useRef(null);

useEffect(() => {
    const modal = document.getElementById("TwoFactorPreRegSettingModal");
    const handleShow = () => {
        setTimeout(() => firstFocusableRef.current?.focus(), 100);
    };
    const handleHidden = () => {
        // When TwoFactor modal closes, restore modal-open on body if another
        // modal (e.g. user details) is still visible so it keeps functioning.
        if (document.querySelector(".modal.show")) {
            document.body.classList.add("modal-open");
        }
    };
    modal?.addEventListener("shown.bs.modal", handleShow);
    modal?.addEventListener("hidden.bs.modal", handleHidden);
    return () => {
        modal?.removeEventListener("shown.bs.modal", handleShow);
        modal?.removeEventListener("hidden.bs.modal", handleHidden);
    };
}, []);

  const setAnswer = async (questionId, answer) => {
    setAnswers({ ...answers, [questionId]: answer });
  };

  useEffect(() => {
    SetErrCreateMsg(false);
    return () => {
      setAnswers(obj);
      setFlagSuccess(false);
    };
  }, []);

  const SubmitForm = async () => {
    setFlag(false);
    SetErrCreateMsg(false);
    SetErrMsg(false);
    setFlagSuccess(false);
    SetErrEmail(false);
    if (answers.contactEmail || answers.phone) {
      if (
        !isEmpty(answers.contactEmail) &&
        !validEmail(answers.contactEmail)
      ) {
        SetErrEmail(true);
        return;
      }

      let call = `/users/ValidateTFASettings?tfaPhone=${
        answers.phone ? answers.phone : ""
      }&tfaEmail=${answers.contactEmail ? answers.contactEmail : ""}&tfaOn=${
        answers.tfaOn
      }&userId=-1`;
      setProcessing(true);
      SetSharedObject("UserPreRegTwoFactor", answers);
      const res = await CallAPI(call, false, "get", userToken);
      SetSharedObject("ResponseCode", res.code);

      if (res.status === "SUCCESS") {
        setProcessing(false);
        setFlagSuccess(true);
        CloseModal();
      } else if (res.status === "SERVERERROR") {
        let msg = res.data;
        let str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetErrMsg(str);
        SetErrCreateMsg(true);
        setProcessing(false);
      }
    } else {
      setFlag(true);
      return;
    }
  };

  const changeTFA = () => {
      setAnswer("tfaOn", !answers.tfaOn);
  };

  const CloseModal = async () => {
    let obj = {
      contactEmail: "",
      phone: "",
      tfaOn: false,
    };
    setAnswers(obj);
    SetSharedObject("AddTfaFlag", true);
    setFlagSuccess(false);
    SetErrCreateMsg(false);
    CloseModal();

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    modalTriggerRef.current?.focus();
  };
  // Keyboard support for Esc to close modal
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        CloseModal();
      }
    };
    if (modalRef.current) {
      modalRef.current.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      if (modalRef.current) {
        modalRef.current.removeEventListener("keydown", handleKeyDown);
      }
    };
  }, []);
  const setPhone = async (val) => {
      setAnswer("phone", val !== "" ? val : null);
  };

  const setEmail = async (val) => {
    setAnswer("contactEmail", val !== "NotProvided" ? val : null);
  };

  function formatContactEmail(val) {
      return val === "NotProvided" ? "" : val;
  }

  function isEmpty(value) {
      return value == null || (typeof value === "string" && value.trim().length === 0);
  }
  // Build a plain-text version of the server error for aria-live so
  // screen readers announce it without relying on dangerouslySetInnerHTML.
  const serverErrText =
    Array.isArray(errMsg)
      ? errMsg.join(" ")
      : typeof errMsg === "string"
      ? errMsg.replace(/<[^>]+>/g, " ").trim()
      : "";

  return (
    <div className="TwoFactor">
      <div
        className="modal fade"
        id="TwoFactorPreRegSettingModal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="TwoFactorPreRegSettingModalTitle"
        aria-describedby="TwoFactorPreRegSettingModalDesc"
        data-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h3
                className="modal-title"
                id="TwoFactorPreRegSettingModalTitle"
                aria-level="2"
             >
                Two-Factor Authentication Setting
              </h3>
              <button
                type="button"
                className="close"
                onClick={CloseModal}
                aria-label="Close Two-Factor Authentication Setting dialog"
                ref={closeBtnRef}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {flagSuccess ? (
                <>
                  <div className="bi-success-check" aria-label="Success">
                    <i className="bi bi-check2-circle" aria-hidden="true"></i>
                  </div>
                  <div
                    className="message-wrapper"
                    aria-live="polite"
                    role="status"
                    aria-atomic="true"
                    >
                    Two-Factor Authentication has been saved successfully.
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="descript-container"
                    id="TwoFactorPreRegSettingModalDesc"
                    >
                    Two-factor authentication is an enhanced security measure.
                    Once enabled, users will be prompted for additional
                    authentication code.
                  </div>
                  <div className="field-wrapper modal-content-form">
                    <label htmlFor="tfa-phone">Code Sent by Text Message</label>
                    <div>
                      <input
                        id="tfa-phone"
                        ref={firstFocusableRef}
                        type="tel"
                        name="Phone"
                        className="form-control"
                        onChange={(el) => setPhone(el.target.value)}
                        value={formatPhoneNumber(answers.phone)}
                        autoComplete="tel"
                        aria-describedby={flag ? "tfa-phone-error" : undefined}
                      />
                      {flag && (
                        <span id="tfa-phone-error" className="sr-only" role="alert">
                          Either Contact Email or Phone Number is required.
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="field-wrapper modal-content-form">
                    <label htmlFor="tfa-email" id="tfa-email-desc">Code Sent by Email</label>
                    <div>
                      <input
                        id="tfa-email"
                        type="email"
                        name="ContactEmail"
                        className="form-control"
                        value={formatContactEmail(answers.contactEmail)}
                        onChange={(el) => setEmail(el.target.value)}
                        autoComplete="email"
                        aria-describedby={
                            errEmail
                                ? "tfa-email-error"
                                : "tfa-email-hint"
                        }
                      />
                    </div>
                    <div
                        className="descript2-container line-s1 sp-margin3"
                        id="tfa-email-hint"
                     >
                      Email will be used if mobile number is not available.
                    </div>
                  </div>
                  {flag && (
                    <div
                      id="tfa-email-error"
                      className="alert alert-danger field-wrapper modal-content-form"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                    >
                      Either Contact Email or Phone Number is required.
                    </div>
                  )}
                  <div className="field-wrapper modal-content-form">
                    <label id="tfa-toggle-label">Turn On:</label>
                    <button
                      type="button"
                      className={`btn btn-link sp-pad0 v-set3 ${answers.tfaOn ? "bi bi-shield-fill-check" : "bi bi-shield-slash gray"}`}
                      aria-pressed={answers.tfaOn}
                      aria-label={
                        answers.tfaOn
                          ? "Disable Two-Factor Authentication"
                          : "Enable Two-Factor Authentication"
                      }
                      title={
                        answers.tfaOn
                          ? "Two-Factor Authentication Enabled"
                          : "Two-Factor Authentication Disabled"
                      }
                      onClick={(el) => {
                        changeTFA();
                        el.preventDefault();
                      }}
                      aria-labelledby="tfa-toggle-label"
                    >
                      <span className="sr-only">
                        {answers.tfaOn
                          ? "Two-Factor Authentication Enabled"
                          : "Two-Factor Authentication Disabled"}
                      </span>
                    </button>
                  </div>
                </>
              )}
              {errCreateMsg ? (
                <>
                  <div
                  className={`alert alert-danger`}
                  dangerouslySetInnerHTML={{ __html: errMsg }}
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                  id="tfa-server-error"
                />
                {/* Visually hidden text-only version for AT, uses serverErrText */}
                <div
                  className="sr-only"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  {serverErrText}
                </div>
                </>
              ) : null}
              {errEmail ? (
                <div
                    id="tfa-email-error"
                    className={`alert alert-danger`}
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    >
                  Please enter a valid email name with more than 4 characters
                  long, no spaces, commas, or special characters.
                </div>
              ) : null}
            </div>
            <div className="modal-footer">
              {flagSuccess ? (
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={CloseModal}
                  ref={closeBtnRef}
                >
                  Close
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() => SubmitForm()}
                    disabled={processing}
                    aria-busy={processing}
                  >
                    {processing ? "Saving..." : "Save"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={CloseModal}
                    ref={closeBtnRef}
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoFactorPreReg;
